import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pantry-image-select-view" }
const _hoisted_2 = { class: "pantry-image-select-view-item-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryImageSelectItem = _resolveComponent("PantryImageSelectItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList, (item) => {
        return (_openBlock(), _createBlock(_component_PantryImageSelectItem, {
          class: "pantry-image-select-view-item",
          key: item.id,
          data: item,
          selectRoomId: _ctx.selectRoomId,
          onSelectRoom: _ctx.onSelectRoom
        }, null, 8, ["data", "selectRoomId", "onSelectRoom"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}